import TrustedAppsList from './TrustedAppsList'

export default TrustedAppsList
